import { databaseDtoSchema, dateDtoSchema, nullable } from 'utility/schema';
import { z } from 'zod';

const aggregatedActivityDtoSchema = dateDtoSchema.merge(
  z.object({
    activityTypeId: z.string(),
    activityId: z.string(),
    employeeId: nullable(z.string()),
    spentTime: z.number(),
  }),
);

const calculatedDtoSchema = dateDtoSchema.merge(
  z.object({
    companyId: z.string(),
    zoneId: z.string(),
    subZoneId: nullable(z.string()),
    receivedItemCount: nullable(z.number()),
    processedItemCount: nullable(z.number()),
    backlogItemCount: nullable(z.number()),
    unitOfMeasureId: z.string(),
    employeeId: nullable(z.string()),
  }),
);

const nextCalculatedDtoSchema = dateDtoSchema.merge(
  z.object({
    companyId: z.string(),
    zoneId: z.string(),
    subZoneId: nullable(z.string()),
    receivedItemCount: nullable(z.number()),
    processedItemCount: nullable(z.number()),
    backlogItemCount: nullable(z.number()),
    unitOfMeasureId: z.string(),
    employeeId: nullable(z.string()),
    bucketResolution: z.string(),
    hour: z.number(),
    minute: z.number(),
  }),
);

const forecastDtoSchema = databaseDtoSchema.merge(dateDtoSchema).merge(
  z.object({
    id: z.string().uuid(),
    companyId: z.string().uuid(),
    zoneId: nullable(z.string().uuid()),
    value: z.number(),
    unitOfMeasureId: z.string().uuid(),
    isSystemPrediction: z.boolean().catch(false),
    isCreatedByUser: z.boolean().catch(false),
    PredictionConfidence: z.number().nullable(),
  }),
);

export type AggregatedActivityDto = z.infer<typeof aggregatedActivityDtoSchema>;
export type CalculatedDto = z.infer<typeof calculatedDtoSchema>;
export type NextCalculatedDto = z.infer<typeof nextCalculatedDtoSchema>;
export type ForecastDto = z.infer<typeof forecastDtoSchema>;

export {
  aggregatedActivityDtoSchema,
  calculatedDtoSchema,
  forecastDtoSchema,
  nextCalculatedDtoSchema,
};
